import React from 'react';
import { Eyebrow, Section } from './Section';
import { ComparisonTable } from './ComparisonTable';
import { costRows } from '../data/comparisons';
export function CostOfInaction() {
  return <Section tone="paper" labelledBy="cout-title" data-id="element-67" data-mp="2uxavyq5wmonr">
      <Eyebrow data-id="element-68" data-mp="2uwj0dfcb4qxh">Le coût d’un parcours sans cadre</Eyebrow>
      <h2 id="cout-title" className="max-w-3xl font-serif text-3xl font-semibold leading-[1.15] text-graphite md:text-[2.75rem]" data-id="element-69" data-mp="2zx6zkoaowe2s">
        Que coûte, concrètement, un parcours sans cadre ?
      </h2>

      <div className="mt-12" data-id="element-70" data-mp="38wahvq218pg8">
        <ComparisonTable rows={costRows} beforeLabel="Sans cadre" afterLabel="Ce que cela coûte" caption="Ce que coûte un parcours sans cadre" data-id="element-71" data-mp="38viqkrfgxdvr" />
      </div>

      <p className="mt-6 max-w-3xl text-xs leading-relaxed text-warm" data-id="element-72" data-mp="3ip979a5csk0w">
        À titre d’exemple, sur une base prudente de 80 € la séance, un parcours
        interrompu à la quatrième séance représente environ 480 € de moins qu’un
        parcours de dix séances mené à terme. Illustration issue du Tome 1, sans
        promesse de résultat.
      </p>

      <div className="mt-14 max-w-3xl border-t border-warm-line pt-10" data-id="element-73" data-mp="39gbvyp23na71">
        <p className="font-serif text-2xl italic leading-relaxed text-graphite md:text-3xl" data-id="element-74" data-mp="34hqpw9061wao">
          Le système complet coûte moins cher qu’une seule séance de coaching.
        </p>
        <p className="mt-5 text-base text-graphite-mid" data-id="element-75" data-mp="11jwqwfdnhg5">
          Votre prochaine quatrième séance peut se passer autrement.
        </p>
      </div>
    </Section>;
}